import React, { useState } from 'react';
import Button from '../form-control/Button';
import FileUpload from '../elements/FileUpload/FileUpload';
import { useQueryClient } from '@tanstack/react-query';
import { showToast } from '../../utils/miscFunctions';

interface IFleetProps {
    onProceed: (file:File) => void;
    onClose?: () => void;
}
const FleetModal = ({onProceed, onClose}:IFleetProps) => {

    const [loading, setLoading] = useState<boolean>(false);
    const [uploadedFleet, setUploadedFleet] = useState<File | null>(null);
    const queryClient = useQueryClient();


    const handleSubmit: React.FormEventHandler<HTMLFormElement> = async (event) => {
      event.preventDefault();
      try {
        if (uploadedFleet) {
            //setLoading(true);
            onProceed(uploadedFleet);
        }
      } catch (error: any) {
        showToast.error(error.description ?? 'Failed to upload evidence');
      } finally {
        setLoading(false);
      }
    };

    return (
      <div className="p-5 rounded-xl">
        <form onSubmit={handleSubmit}>
          <FileUpload
            type="csv"
            label="Upload fleet datasheet"
            label2="Download template"
            onFileLoad={(file: any) => {
              if (file && file[0]) {
                setUploadedFleet(file[0]);
              }
            }}
            showFileMax={false}
            onFileDeleted={() => {
              setUploadedFleet(null);
            }}
            defaultImage={''}
            cropImage={false}
            maxHeight={90}
            maxWidth={200}
            imageContainerHeight={'200px'}
            imageAlt={'Fleet'}
          />

          <div className="w-full flex gap-4 ">
            <Button
              type="button"
              label="Cancel"
              onClick={onClose}
              bgColor='secondary'
                  fullWidth
             
            />
            <Button
              type="submit"
              label="Upload"
              bgColor='primary'
              fullWidth
              disabled={loading}
              loading={loading}
            />
          </div>
        </form>
      </div>
    );
  };


export default FleetModal;
